import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=0c16858e&scoped=true&"
import script from "./SignUpModal.vue?vue&type=script&lang=js&"
export * from "./SignUpModal.vue?vue&type=script&lang=js&"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=0c16858e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16858e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c16858e')) {
      api.createRecord('0c16858e', component.options)
    } else {
      api.reload('0c16858e', component.options)
    }
    module.hot.accept("./SignUpModal.vue?vue&type=template&id=0c16858e&scoped=true&", function () {
      api.rerender('0c16858e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/modals/SignUpModal.vue"
export default component.exports